<template>
    <div class="warp_found">
        <div class="found">404 Not Found 
            <div></div>
            <span>您访问的页面不存在</span>
        </div>
        
    </div>
</template>
<script>
export default {
    data() {
        return {
            selected: ''
        }
    },
    created() {

    },
    beforeCreate() {

    },
    mounted() {

    },
    methods: {
    
    },
    computed: {

    }
}
</script>
<style>
.warp_found{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}
.found{
    height: 30%;
    width: 100%;
    font-size: 32px;
    text-align: center;
}
.found div{
    margin-top: 30px;
    width: 100%;
    height: 2px;
    background: #000;
}
</style>



// WEBPACK FOOTER //
// 404.vue?f74be6c2